package com.devi3east.bashbuddy.auth.util

import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

fun parseRecoveryToken(url: String): String {
    if (url.isBlank()) return ""

    val (beforeFragment, fragmentPart) = if (url.contains("#")) {
        val parts = url.split("#", limit = 2)
        Pair(parts[0], parts.getOrNull(1) ?: "")
    } else Pair(url, "")

    // Parse fragment first (Supabase puts real token there)
    val fragmentParams = fragmentPart
        .split("&")
        .mapNotNull {
            val kv = it.split("=", limit = 2)
            if (kv.isEmpty()) null else kv[0] to (kv.getOrNull(1) ?: "")
        }
        .toMap()

    val tokenFromFragment = fragmentParams["access_token"]?.takeIf { it.isNotBlank() } ?: fragmentParams["token"]
    if (!tokenFromFragment.isNullOrBlank()) {
        return tokenFromFragment
    }

    // Fallback to query only if fragment is missing
    val queryString = beforeFragment.substringAfter("?", "")
    val queryParams = queryString
        .split("&")
        .mapNotNull {
            val kv = it.split("=", limit = 2)
            if (kv.isEmpty()) null else kv[0] to (kv.getOrNull(1) ?: "")
        }
        .toMap()

    val tokenFromQuery = queryParams["token"]?.takeIf { it.isNotBlank() } ?: queryParams["access_token"]
    if (!tokenFromQuery.isNullOrBlank()) {
        return tokenFromQuery
    }

    return ""
}

fun calculateAge(dateOfBirth: String): Int {
    val dob = runCatching { LocalDate.parse(dateOfBirth) }.getOrNull() ?: return 0
    val today = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date

    var age = today.year - dob.year
    if (today.monthNumber < dob.monthNumber || (today.monthNumber == dob.monthNumber && today.dayOfMonth < dob.dayOfMonth)) {
        age -= 1
    }
    return age
}